// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k8-0";
export var fileCarousel = "_k8-2";
export var removeFileButton = "_k8-1";